import * as XLSX from "xlsx";

/* Shared SheetJS wrapper. Every module uses this for the Excel export
 * action so filename, header style and number formatting stay identical
 * across the app.
 *
 * downloadXlsx(filenameBase, mode, sheets):
 *   filenameBase — module name, e.g. "Invoices", "Bills"
 *   mode         — "Summary" or "Detail" (becomes filename suffix)
 *   sheets       — { sheetName: rows[] } — one or more named sheets,
 *                  each row a flat object whose keys become column
 *                  headers in that order.
 *
 * Filename convention (matches the user spec):
 *   GFI_<filenameBase>_<mode>_<YYYY-MM-DD>.xlsx
 */
export function downloadXlsx(filenameBase, mode, sheets) {
  var wb = XLSX.utils.book_new();
  var names = Object.keys(sheets || {});
  if (names.length === 0) return;
  names.forEach(function (name) {
    var rows = sheets[name] || [];
    var ws = XLSX.utils.json_to_sheet(rows);
    XLSX.utils.book_append_sheet(wb, ws, name.slice(0, 31)); /* Excel sheet name cap */
  });
  var d = new Date();
  var iso = d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
  var fname = "GFI_" + filenameBase + "_" + mode + "_" + iso + ".xlsx";
  XLSX.writeFile(wb, fname);
}

/* Round to 2 decimals; blank for non-numeric. Use for $ columns so
   Excel displays the value as a real number (sortable, summable). */
export function num2(v) {
  var n = parseFloat(v);
  if (isNaN(n)) return "";
  return Math.round(n * 100) / 100;
}

/* Integer cast; blank for non-numeric. */
export function intOr(v) {
  var n = parseInt(v, 10);
  if (isNaN(n)) return "";
  return n;
}

/* Pass-through string, blank-safe. */
export function s(v) {
  if (v === undefined || v === null) return "";
  return String(v);
}
